import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export function SchoolsLayout() {
  return (
    <Box sx={{ width: '100%' }}>
      <Outlet />
    </Box>
  );
}
